"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMMDD = exports.getFullTime = exports.parseDate = void 0;
exports.parseDate = {
    ISOStrToDate(ISOString) {
        return new Date(Date.parse(ISOString));
    },
};
const getFullTime = () => {
    const date = new Date();
    const numberDateObj = {
        month: date.getMonth() + 1,
        day: date.getDate(),
        hour: date.getHours(),
        minute: date.getMinutes(),
        second: date.getSeconds(),
        msSecond: date.getMilliseconds(),
    };
    const { month, day, hour, minute, second, msSecond } = numberDateObj;
    const stringDateObj = {
        monthStr: month >= 10 ? month.toString() : "0" + month.toString(),
        dayStr: day >= 10 ? day.toString() : "0" + day.toString(),
        hourStr: hour >= 10 ? hour.toString() : "0" + hour.toString(),
        minuteStr: minute >= 10 ? minute.toString() : "0" + minute.toString(),
        secondStr: second >= 10 ? second.toString() : "0" + second.toString(),
        msSecondStr: msSecond >= 100 ? msSecond.toString() : "0" + msSecond.toString(),
    };
    const { monthStr, dayStr, hourStr, minuteStr, secondStr, msSecondStr } = stringDateObj;
    const result = date.getFullYear() +
        "-" +
        monthStr +
        "-" +
        dayStr +
        " " +
        hourStr +
        ":" +
        minuteStr +
        ":" +
        secondStr +
        "." +
        msSecondStr;
    return result;
};
exports.getFullTime = getFullTime;
const getMMDD = (date, countour) => {
    const resultCountour = countour ? countour : "";
    return date.getMonth() + 1 + resultCountour + date.getDate();
};
exports.getMMDD = getMMDD;
